import React, { useContext, useEffect, useState } from "react"

import { flex } from "styled-system"

import PlayIcon from "./PlayIcon"
import { PlayerContext } from "../../store/PlayerContext"
import { SVGText, CC, Transcription, Text } from "./styles"
const path = require("svg-path-properties")
import { circlePath } from "../../utils/index"
import { motion, useDragControls } from "framer-motion"
// import {
//   useWindowSize,
//   useWindowWidth,
//   useWindowHeight,
// } from "@react-hook/window-size"
import ForwardIcon from "./ForwardIcon"
import BackwardIcon from "./BackwardIcon"
import { fancyTimeFormat } from "../../utils/index"

type Props = {
  x: number
  y: number
  r: number
}

const MiniPlayer: React.FC<Props> = ({ x, y, r }): JSX.Element | null => {
  const context = useContext(PlayerContext)
  const [cc, setCC] = useState(false)
  // const [width, height] = useWindowSize()
  // const onlyWidth = useWindowWidth()
  // const onlyHeight = useWindowHeight()
  // const dragControls = useDragControls()

  const size = 182
  // const duration = context.player.duration
  // const progress = context.player.progress
  const dasharray = 2 * Math.PI * (size / 2 - 10)
  const properties = new path.svgPathProperties(
    circlePath(size / 2, size / 2 + 30, size / 2 - 10, 0)
  )
  const length = properties.getTotalLength()

  const fixPointAtLength = (
    properties: any,
    length: number,
    progress: number,
    xy: "x" | "y"
  ) => {
    const value = length - progress * length - length / 4

    const point = properties.getPointAtLength(value)

    if (value <= 0) {
      return properties.getPointAtLength(length * 1.75 - length * progress)[xy]
    }

    return point[xy]
  }

  return (
    <>
      <div
        // onPointerDown={startDrag}
        style={{
          position: "fixed",
          top: y + r - 140,
          left: x + r - 140,
          width: `200px`,
          height: `200px`,
          // background: `radial-gradient(#000000 10%, #df4a32 30%, transparent 50%)`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}
      >
        <svg
          width={size}
          height={size + 60}
          viewBox={`0 0 ${size} ${size + 60}`}
        >
          <image
            x={5}
            y={35}
            width={size - 10}
            height={size - 10}
            href={"/head.png"}
          ></image>
          <circle
            fill={"transparent"}
            transform={`rotate(90)`}
            stroke={"#df4a32"}
            strokeDasharray={dasharray}
            strokeDashoffset={dasharray - dasharray * context.player.progress}
            strokeWidth={2}
            r={size / 2 - 10}
            cx={size / 2}
            cy={size / 2 + 30}
            style={{
              transformOrigin: "50% 50%",
            }}
          ></circle>
          <SVGText textLength={size / 2} x={size / 4} y={160}>
            {fancyTimeFormat(
              context.player.progress * Number(context.player.duration)
            )}
            /{fancyTimeFormat(Number(context.player.duration))}
          </SVGText>
          <motion.circle
            // whileDrag={{ scale: 1.2 }}
            style={{
              cursor: "pointer",
            }}
            // transform={`rotate(90)`}
            r={7}
            fill={"#df4a32"}
            cx={fixPointAtLength(
              properties,
              length,
              context.player.progress,
              "x"
            )}
            cy={fixPointAtLength(
              properties,
              length,
              context.player.progress,
              "y"
            )}
          ></motion.circle>
          <foreignObject width={60} height={60} x={size / 2 - 30} y={size}>
            <PlayIcon
              control={() => {
                ////console.log("Play")
                context.setPlayerContext({
                  type: "SET_PLAYER",
                  payload: {
                    playing: !context.player.playing,
                  },
                })
              }}
              play={context.player.playing}
            ></PlayIcon>
          </foreignObject>
          <foreignObject width={28} height={28} x={size / 4 - 14} y={size + 30}>
            <BackwardIcon />
          </foreignObject>
          <foreignObject
            width={28}
            height={28}
            x={(size / 4) * 3 - 14}
            y={size + 30}
          >
            <ForwardIcon />
          </foreignObject>
        </svg>
        {context.player.description && (
          <CC
            onClick={() => {
              setCC(!cc)
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path fill="none" d="M0 0H24V24H0z"></path>
              <path fill={"#dad2d2"} d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
              <path fill={"#dad2d2"} d="M14 17H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"></path>
            </svg>
          </CC>
        )}
      </div>
      {cc && (
        <Transcription>
          <motion.div
            style={{
              transform: `translateY(${-context.player.progress * 100 * 0.8}%)`,
            }}
          >
            <Text>{context.player.description}</Text>
          </motion.div>
        </Transcription>
      )}
    </>
  )
}

export default MiniPlayer
